import categoryQueries from '@apis/queries/categoryQueries';
import useToast from '@hooks/ui/useToast';
import { useFlow } from '@stackflow/react';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

function useItemCategories(shopId: string) {
    const { data, status } = useQuery(categoryQueries.list(shopId));
    const { pop } = useFlow();
    const toast = useToast();
    const categories = data?.categories;
    const isLoading = status === 'pending';
    const isBlank = status !== 'pending' && (!categories || categories.length === 0);
    useEffect(() => {
        if (status === 'error') {
            pop();
            toast.error('카테고리 조회 중 오류가 발생하였습니다.');
        }
    }, [status]);
    return { categories, isLoading, isBlank };
}

export default useItemCategories;
